import { getTimerVoice } from './timer-voice';

export function speakMsg(text) {
    const msg = new SpeechSynthesisUtterance();
    msg.text = text;
    msg.voice = getTimerVoice();
    speechSynthesis.speak(msg);
}
